import styled from 'styled-components';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

export const StyledGrid = styled(Grid)`
  width: 100vw;
  min-height: 100vh;
  background: ${({ theme }) => theme.color.noir};
  position: absolute;
  top: 0;
  left: 0;
`;

export const StickyGrid = styled(Grid)`
  position: sticky;
  top: ${({ theme }) => `calc(0px - ${theme.safeAreaInsetTop})`};
  ${media.mdUp`
    top: -${({ theme }) => theme.x4spacePx}px;
  `}
  background: ${({ theme }) => theme.color.noir};
  padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x2spacePx}px`};
  padding-top: ${({ theme }) =>
    `calc(${theme.x1spacePx}px + ${theme.safeAreaInsetTop})`};
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
`;

export const ChartWrapper = styled('div')`
  padding: ${({ theme }) => theme.x3spacePx}px;
  padding-left: 0px;
  ${media.lgUp`
    padding: ${({ theme }) => theme.x5spacePx}px;
    padding-left: 0px;
  `}
`;
